import { useEffect } from "react";
import { useMaintenance } from "../hooks/useMaintenance";


export const CheckHealth: React.FC = () => {

    const { checkHealth } = useMaintenance( );

    useEffect( ( ) => { checkHealth( ) }, [ ] );
    
    return( <></> );

};